import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

function HubSpotConnect({ onConnect }) {
  const [installUrl, setInstallUrl] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const { user } = useAuth();

  useEffect(() => {
    if (user && user.token) {
      fetchInstallUrl();
    }
  }, [user]);

  const fetchInstallUrl = async () => {
    try {
      setLoading(true);
      console.log('Fetching install URL for user:', user.id);
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/auth/hubspot-install-url`, {
        headers: {
          'Authorization': `Bearer ${user.token}`,
          'Content-Type': 'application/json'
        }
      });
      console.log('Received install URL:', response.data.installUrl);
      setInstallUrl(response.data.installUrl);
      setError('');
    } catch (error) {
      console.error('Failed to fetch HubSpot install URL:', error);
      setError('Failed to fetch HubSpot install URL');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="hubspot-connect">
      {error && (
        <div className="connect-error">
          <p>{error}</p>
          <button onClick={fetchInstallUrl} className="btn btn-secondary btn-sm">
            Try Again
          </button>
        </div>
      )}
      
      {loading ? (
        <div className="connect-loading">
          <div className="loading-spinner"></div>
          <p>Loading connection URL...</p>
        </div>
      ) : installUrl && !error ? (
        <div className="connect-ready">
          <a 
            href={installUrl} 
            target="_blank" 
            rel="noopener noreferrer"
            className="btn btn-primary hubspot-btn"
          >
            Connect to HubSpot
          </a>
        </div>
      ) : null}
    </div>
  );
}

export default HubSpotConnect;
